"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.forms = void 0;
const basic_1 = require("../basic");
exports.forms = (0, basic_1.applyBase)({
    label: {
        pl: ['5px'],
        color: 'secondary',
        mb: [1, 2],
        span: {
            ml: 1,
        },
    },
    unsubscribeForm: {
        form: {
            maxWidth: '770px',
            p: '30px',
            mx: 'auto',
            mb: [null, '60px'],
            border: '1px solid',
            borderColor: 'lightGreySecond',
            borderRadius: 'default',
            '.unsubscribe-text-input': {
                mb: 4,
                '.input': {
                    backgroundColor: 'bgLightBlue',
                },
            },
        },
        checkboxes: {
            mb: [3, '20px'],
            '.label': {
                color: 'initial',
                pl: 0,
            },
        },
    },
    filtersForm: {
        display: ['grid', 'flex'], // fix firefox sticky covering issue
        flexDirection: 'column',
        maxHeight: '100%',
    },
    fullNameWrapper: {
        display: 'flex',
        flexDirection: 'column',
    },
    bannerFormWrap: {
        backgroundColor: [null, 'bgLightBlue'],
        pt: [0, '120px'],
        position: [null, 'relative'],
        display: [null, 'flex'],
        flexDirection: [null, 'column'],
    },
    bannerForm: {
        position: [null, 'absolute'],
        top: [null, '40px'],
        maxWidth: [null, '1170px'],
        width: [null, '100%'],
        left: [null, '50%'],
        transform: [null, 'translate(-50%)'],
        zIndex: '3',
    },
    staticBannerForm: {
        mx: 'auto',
    },
    shortBannerForm: {
        position: 'static',
        transform: 'none',
        borderRadius: 'default',
        boxShadow: '0 2px 4px 2px rgba(0,0,0,0.06)',
        mb: [null, '20px'],
        '.form-container': {
            textAlign: 'center',
            pt: 3,
            px: [null, '24px'],
            pb: 3,
            '& .input': {
                height: [null, '48px'],
                fontSize: [null, 2],
            },
            '& .input ~ .icon': {
                left: [null, '15px'],
            },
        },
        '.travelTypes': {
            mb: 0,
        },
        '.tabControls': {
            height: ['50px', '58px'],
            px: 4,
        },
        '.travelTypeItem': {
            flex: '0 0 auto',
        },
    },
    emailForm: {
        submitButtonWrapper: {
            display: 'flex',
            flexDirection: ['column', 'row-reverse'],
            justifyContent: 'space-between',
            p: {
                fontSize: 1,
                maxWidth: [null, '400px'],
            },
            '.form-submit-button': {
                width: ['100%', '140px'],
                marginLeft: 'auto',
                mb: [4, 0],
            },
        },
        maxWidth: '770px',
        p: '30px',
        mx: 'auto',
        mb: [null, '60px'],
        border: '1px solid',
        borderColor: 'lightGreySecond',
        borderRadius: 'default',
        '.radio-group-input': {
            div: {
                display: 'flex',
                flexDirection: 'row',
                mb: 3,
            },
            '.label': {
                mr: 4,
                pl: 0,
            },
        },
        '.text-input': {
            marginBottom: 4,
        },
        '.error': {
            mt: -3,
            mb: 3,
        },
    },
    registrationForm: {
        '.error-message-wrap': {
            my: 3,
            '.account-already-exists-error': {
                color: 'primary',
            },
        },
        '.checkbox-input-wrap': {
            mb: 3,
            '.label': {
                color: 'initial',
                pl: 0,
            },
        },
        '.registration-login-link': {
            fontSize: 2,
            fontWeight: 600,
            display: 'inline-block !important',
        },
        '.submit-button-wrapper': {
            display: 'flex',
            flexWrap: 'wrap',
            gap: [2, 3],
            flexDirection: ['column', 'row-reverse'],
            justifyContent: 'space-between',
            p: {
                fontSize: 1,
            },
            '.form-submit-button': {
                width: ['100%', '140px'],
                marginLeft: 'auto',
            },
        },
        maxWidth: '770px',
        p: '30px',
        mx: 'auto',
        mb: [null, '60px'],
        border: '1px solid',
        borderColor: 'lightGreySecond',
        borderRadius: 'default',
        '.radio-group-input': {
            div: {
                display: 'flex',
                flexDirection: 'row',
                mb: 3,
            },
            '.label': {
                mr: 4,
                pl: 0,
            },
        },
        '.text-input': {
            marginBottom: 3,
        },
        '.error': {
            mt: -3,
            mb: 3,
            color: 'error',
        },
    },
    customCheckboxControl: {
        height: ['25px', '20px'],
        width: ['25px', '20px'],
        position: 'relative',
        border: '1px solid',
        borderColor: 'borderColor',
        borderRadius: '2px',
        order: -1,
        marginRight: [2, '10px'],
        backgroundColor: 'white',
        flexShrink: 0,
        '&::after': {
            content: "''",
            position: 'absolute',
            opacity: 0,
            left: ['7px', '6px'],
            top: ['1px', '2px'],
            width: ['8px', '6px'],
            height: ['17px', '12px'],
            border: '1px solid',
            borderColor: 'primary',
            borderWidth: '0 2px 2px 0',
            transform: 'rotate(40deg)',
        },
    },
});
//# sourceMappingURL=forms.js.map